import { Component, OnInit } from '@angular/core';
import { PropertiesService, PropertyPageEnum } from '../properties.service';

import { ActivatedRoute, Router, NavigationEnd, Event } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { Property } from 'models/property.model';
import { LayoutService } from '../layout.service';
declare var feather:any;

@Component({
  selector: 'app-navigation-sidebar',
  templateUrl: './navigation-sidebar.component.html',
  styleUrls: ['./navigation-sidebar.component.scss']
})
export class NavigationSidebarComponent implements OnInit {
  public currentPage: string;
  

  constructor(private layoutService: LayoutService, private authService: AuthService, private router: Router, private route: ActivatedRoute, private properties: PropertiesService) {
    feather.replace();
    this.properties.currentMessage.subscribe(message => feather.replace());

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        console.log(`Navigation End Event Called ${val.url}`);
        this.currentPage = val.url;
      }
    });
  }

  ngOnInit() {
    this.properties.currentMessage.subscribe(message => {
      console.log('got a message', message);  
      feather.replace();
    });
    setTimeout(() => {
      feather.replace();
    }, 100);
  }

  setProperty = (property: Property) => {
    this.properties.currentProperty = property;
    this.router.navigate(['dashboard']);
  }

  setActivePage = (page: PropertyPageEnum) => {
    this.properties.activatePage = page;
  }

}
